/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSites } from '../fn/site/get-sites';
import { GetSites$Params } from '../fn/site/get-sites';
import { Site } from '../models/site';

@Injectable({ providedIn: 'root' })
export class SiteApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSites()` */
  static readonly GetSitesPath = '/sites';

  /**
   * Retrieve all the sites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSites()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSites$Response(params?: GetSites$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Site>>> {
    const obs = getSites(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all the sites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSites$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSites(params?: GetSites$Params, context?: HttpContext): Observable<Array<Site>> {
    const resp = this.getSites$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Site>>): Array<Site> => r.body)
    );
  }

}
